module.exports = __webpack_public_path__ + "static/media/fund_house_icon.4f702ed8.svg";